<template>
  <div class="workTaskPassIist">
    <Header title="申请信息" type="0" :route="this.params.route"></Header>
    <div class="train">
      <div class="list-head">
        <p>{{ list.rwnr }}</p>
        <van-row>
          <van-col span="24">
            <ul>
              <li>学年学期：{{ list.xnxq }}</li>
              <li>申请单位：{{ list.sqdw }}</li>
              <li>分类：{{ list.fl }}</li>
              <li>劳动强度：{{ list.ldqd }}</li>
              <li>劳动开始时间：{{ list.ldkssj }}</li>
              <li>劳动结束时间：{{ list.ldjssj }}</li>
              <li>劳动地点：{{ list.lddd }}</li>
            </ul>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="pass()">审核</button>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      sqyy: "",
      list: [],
      params: []
    };
  },
  created() {
    this.params = JSON.parse(this.$route.query.list);
    this.getList();
  },
  methods: {
    pass() {
      this.params.route1 = "/workTaskPass/list";
      this.$router.push({
        path: "/freePass/pass",
        query: {
          list: JSON.stringify(this.params)
        }
      });
    },
    async getList() {
      const res = await Api.query_ldrwshDetail({
        ywid: this.params.ywid
      });
      if (res.code == "0") {
        this.$toast(res.Msg);
        setTimeout(() => {
          this.$router.back();
        }, 2000);
      } else {
        this.list = res.data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.workTaskPassIist .train {
  padding: 5% 5% 0;
  padding-bottom: 120px;
  box-sizing: border-box;
  overflow: auto;
  .list-head {
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    padding: 6% 7%;
    box-sizing: border-box;
    margin-bottom: 5%;
    position: relative;
    flex-direction: column;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bold;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 1%;
      font-weight: lighter;
    }
    span {
      position: absolute;
      top: 15%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }
  }
  .title {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    letter-spacing: 0;
    margin-bottom: 2%;
    text-align: center;
    font-weight: bold;
  }
  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 5%;
  padding-bottom: 20px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/workTaskPass/list.vue